var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0103 3.5L26.124 22.75C26.2264 22.9274 26.2803 23.1285 26.2803 23.3333C26.2803 23.5381 26.2264 23.7393 26.124 23.9167C26.0216 24.094 25.8743 24.2413 25.697 24.3437C25.5196 24.4461 25.3185 24.5 25.1137 24.5H2.88633C2.68154 24.5 2.48036 24.4461 2.30301 24.3437C2.12566 24.2413 1.97839 24.094 1.87599 23.9167C1.7736 23.7393 1.71969 23.5381 1.7197 23.3333C1.7197 23.1285 1.7736 22.9274 1.876 22.75L12.9897 3.5C13.0921 3.32266 13.2393 3.17539 13.4167 3.07301C13.594 2.97062 13.7952 2.91672 14 2.91672C14.2048 2.91672 14.406 2.97062 14.5833 3.07301C14.7607 3.17539 14.9079 3.32266 15.0103 3.5ZM12.8333 18.6667V21H15.1667V18.6667H12.8333ZM12.8333 10.5V16.3333H15.1667V10.5H12.8333Z",
    fill: "#FBC02D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.099d59b7d8ef47e75d1f453163b68d84.svg";
export { ForwardRef as ReactComponent };